import Vue from 'vue';
import Router from 'vue-router';

/* IMPORT VIEWS
-------------------------------------------------------------- */
import MainPage from '@/main.vue';

/* IMPORT ROUTERS
-------------------------------------------------------------- */
import dashboardRouter from './dashboard';
import partnersRouter from './partners';
import customersRouter from './customers';
import loginRouter from './login';
import invoicesRouter from './invoices';
import standingDataRouter from './standingData';
import ordersRouter from './orders';
import orderLinesRouter from './orderLines';
import quotesRouter from './quotes';
import profileRouter from './profile';
import adminAuthRouter from './adminAuth';
import app from '@/app.vue';

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location: any) {
  // @ts-ignore
  return originalPush.call(this, location).catch((err: any) => {
    if (err.name !== 'NavigationDuplicated') {
      throw err;
    }
  });
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'app',
      path: '/',
      component: app,
      redirect: '/dashboard',
    },
    {
      name: 'dashboardMain',
      path: '/',
      component: MainPage,
      redirect: '/dashboard',
      children: [
          dashboardRouter,
      ],
    },
    {
      name: 'login',
      path: '/',
      component: MainPage,
      redirect: '/login',
      children: [
          loginRouter,
      ],
    },
    {
      name: 'partnersMain',
      path: '/',
      component: MainPage,
      redirect: '/partner',
      children: [
          partnersRouter,
      ],
    },
    {
      name: 'customersMain',
      path: '/',
      component: MainPage,
      redirect: '/customer',
      children: [
          customersRouter,
      ],
    },
    {
      name: 'invoicesMain',
      path: '/',
      component: MainPage,
      redirect: '/invoices',
      children: [
          invoicesRouter,
      ],
    },
    {
      name: 'standingDataMain',
      path: '/',
      component: MainPage,
      redirect: '/standingData',
      children: [
          standingDataRouter,
      ],
    },
    {
      name: 'ordersMain',
      path: '/',
      component: MainPage,
      redirect: '/orders',
      children: [
          ordersRouter,
      ],
    },
    {
      name: 'orderLinesMain',
      path: '/',
      component: MainPage,
      redirect: '/orderlines',
      children: [
        orderLinesRouter,
      ],
    },
    {
      name: 'quotesMain',
      path: '/',
      component: MainPage,
      redirect: '/quotes',
      children: [
        quotesRouter,
      ],
    },
    {
      name: 'profileMain',
      path: '/',
      component: MainPage,
      redirect: '/profile',
      children: [
        profileRouter,
      ],
    },
    {
      name: 'admin',
      path: '/',
      component: MainPage,
      redirect: '/auth/admin',
      children: [
        adminAuthRouter,
      ],
    },
  ],
});
